export const USER_KEYS = {
  main: 'users',
  profile: 'profile',
  settings: 'settings',
};

export const usersQueryKeys = {
  getProfile: () => [USER_KEYS.main, USER_KEYS.profile] as const,
  getSettings: (...args: unknown[]) => [...usersQueryKeys.getProfile(), USER_KEYS.settings, ...args] as const,
};
